/*
 * @Author: LSG
 * @Date: 2021-08-30 17:05:26
 * @LastEditors: DQL
 * @LastEditTime: 2022-06-17 10:18:32
 * @Description: file content
 */
import qjglRoutes from './qjgl/qjgl.routes';
import xjglRoutes from './xjgl/xjgl.routes';
const FEATURES_ROUTES = [qjglRoutes, xjglRoutes];
const qxjglRoutes = {
  path: 'qxjgl',
  name: 'qxjgl',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'qxjcx',
      name: 'qxjcx',
      component: () =>
        import(
          /* webpackChunkName: "qxjcx" */ '@/features/attendance/qxjgl/list.vue'
        ),
      meta: {
        navtabTitle: '部门请销假查询',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'view/:qjProcessInsId/:xjProcessInsId?',
      name: 'view',
      component: () =>
        import(
          /* webpackChunkName: "view" */ '@/features/attendance/qxjgl/view.vue'
        ),
      meta: {
        navtabTitle: '请销假申请明细',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'viewByX/:xjProcessInsId',
      name: 'view',
      component: () =>
        import(
          /* webpackChunkName: "view" */ '@/features/attendance/qxjgl/view.vue'
        ),
      meta: {
        navtabTitle: '请销假申请明细',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'grqxj',
      name: 'grqxj',
      component: () =>
        import(
          /* webpackChunkName: "grqxj" */ '@/features/attendance/qxjgl/grqxjcx.vue'
        ),
      meta: {
        navtabTitle: '个人请销假查询',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    ...FEATURES_ROUTES
  ]
};

export default qxjglRoutes;
